// import { errorToast } from "./toast";

// const MAX_REQUEST_SIZE = 200 * 1024 * 1024; // 200 МБ в байтах

// const addFilesAssistant = (data, files, driveFile) => {
//   let requests = [];
//   let formData = new FormData();
//   let currentRequestSize = 0;

//   formData.append("userId", data?.userId);
//   formData.append("assistantId", data?.id);

//   if (driveFile) {
//     formData.append("driveFile", driveFile);
//   }

//   files.forEach((file, index) => {
//     if (file.size > MAX_REQUEST_SIZE) {
//       errorToast(`Файл ${file.name} слишком большой и не может быть загружен.`);
//     } else if (currentRequestSize + file.size <= MAX_REQUEST_SIZE) {
//       formData.append(`file${index + 1}`, file);
//       currentRequestSize += file.size;
//     } else {
//       requests.push(formData);

//       formData = new FormData();
//       formData.append("userId", data?.userId);
//       formData.append("assistantId", data?.id);

//       formData.append(`file${index + 1}`, file);
//       currentRequestSize = file.size;
//     }
//   });

//   if (formData.has("file1")) {
//     requests.push(formData);
//   }

//   return requests;
// };

// export default addFilesAssistant;
import { errorToast } from "./toast";

const MAX_REQUEST_SIZE = 200 * 1024 * 1024; // 200 МБ

const addFilesAssistant = (data, files = [], driveFile) => {
  const requests = [];
  let formData = new FormData();
  let currentRequestSize = 0;
  let fileCounter = 1;
  let hasFiles = false;

  const appendBaseFields = (fd) => {
    fd.append("userId", data?.userId);
    fd.append("assistantId", data?.id);
    if (driveFile) {
      fd.append("driveFile", driveFile);
    }
  };

  appendBaseFields(formData);

  if (Array.isArray(files) && files.length > 0) {
    files.forEach((file) => {
      if (file.size > MAX_REQUEST_SIZE) {
        errorToast(`Файл ${file.name} слишком большой и не может быть загружен.`);
        return;
      }

      if (currentRequestSize + file.size <= MAX_REQUEST_SIZE) {
        formData.append(`file${fileCounter}`, file);
        currentRequestSize += file.size;
        fileCounter++;
        hasFiles = true;
      } else {
        if (hasFiles) {
          requests.push(formData);
        }

        // Начинаем новый пакет
        formData = new FormData();
        currentRequestSize = file.size;
        fileCounter = 1;
        hasFiles = true;

        appendBaseFields(formData);
        formData.append(`file${fileCounter}`, file);
        fileCounter++;
      }
    });

    if (hasFiles) {
      requests.push(formData);
    }
  } else if (driveFile) {
    // Если нет обычных файлов, но есть файл из диска
    requests.push(formData);
  }

  return requests;
};

export default addFilesAssistant;